/* Taken from https://83.136.249.60/js/kimaretargetor.js */
function createCookie(name,value,days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length,c.length);
        }
    }
    return null;
}

var pages = [
    '/asunnon-myynti',
    '/asunnon-myyminen',
    '/etsi-kiinteistonvalittaja',
    '/pohtimassa/asuntojen-videoesittelyt-ja-kiinteist%C3%B6maailman-tarjouskauppa---voittamaton-yhdistelm%C3%A4',
    '/pohtimassa/miten-l%C3%B6yd%C3%A4n-loistov%C3%A4litt%C3%A4j%C3%A4n',
    '/pohtimassa/miten-arvioida-asunnon-hinta',
    '/pohtimassa/asunnon-myynti-ilman-v%C3%A4litt%C3%A4j%C3%A4%C3%A4',
    '/pohtimassa/kannattaako-asunnon-sein%C3%A4t-maalata-ennen-myymist%C3%A4',
    '/pohtimassa/asuntojen-myyntihinnat-ja-hintakehitys',
    '/pohtimassa/asuntojen-myyntiajat',
    '/pohtimassa/kuolinpes%C3%A4n-asunnon-myynti'
];

try {
    if(pages.indexOf(document.location.pathname) !== -1){
        var existing_cookie = readCookie('kotikaynti_widget'),
            converted_cookie = readCookie('kotikaynti_widget_converted');
        if(!existing_cookie && !converted_cookie){
            createCookie('kotikaynti_widget', 1, 365);
        }
    }

    if(document.location.pathname === '/kotikaynti'){
        $('.b-form-on-banner__submit').click(function(){
            createCookie('kotikaynti_widget_converted', 1, 365);
        });
    }
} catch(e){}

